<template>
  <div id="app">
    <nav class="dn-nav navbar fixed-top navbar-light bg-white" v-bind:class="{'invisible': nav_invisible}">
        <img src=".\assets\tab.png" class="dn-tab"  v-on:click="offcanvasOpen">
        <img src=".\assets\logo.png" class="dn-logo">
        <img src=".\assets\what.png" class="dn-what" v-on:click="openWXKF">
        <div class="dn-heading">
          <p class="dn-font-17">{{heading}}</p>
          <p class="dn-font-14 dn-subtitle">{{subtitle}}</p>
        </div>
        <div class="container">
          <div class="navbar-collapse offcanvas-collapse yz-offcanvas-collapse" id="navbar_main"  v-bind:class="{'open': open}">
            <ul class="navbar-nav ml-auto align-items-lg-center">
              <li class="nav-item">
                <a class="nav-link" href="http://support.dailyneaty.com"><span class="dn-font-17">首页</span></a>
              </li>
              <li class="nav-item">
                <a class="nav-link" :href=quickInstallUrl><span class="dn-font-17">快速安装指南</span></a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="https://dailyneatyoss.ezhousetech.net/dnapk/daily-neaty.apk"><span class="dn-font-17">官方APP下载</span></a>
              </li>
              <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" href="#" id="navbar_main_dropdown_1" role="button" v-on:click="menuShow" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span class="dn-font-17">产品使用说明</span></a>
                <div class="dropdown-menu " aria-labelledby="navbar_1_dropdown_1" v-bind:class="{'show': navshow}">
                  <a class="dropdown-item" href="http://manual.ezhousetech.net/电子说明书/DN-MW2BMW2DMW2E-说明书-20241217-v1.pdf"><span class="dn-font-14">标准版使用说明</span></a>
                  <a class="dropdown-item" href="http://manual.ezhousetech.net/电子说明书/MW1C 电子说明书（大水箱版）加水管-20241203-V1.pdf"><span class="dn-font-14">水箱版Ⅱ使用说明</span></a>
                  <a class="dropdown-item" href="http://manual.ezhousetech.net/电子说明书/DN_nix2电子说明书-20250113-v1.pdf" ><span class="dn-font-14">小热石热泵烘干机说明</span></a>
                </div>
              </li>
            </ul>
          </div>
        </div>
    </nav>
    <div v-on:click="offcanvasOpen2">
      <router-view />
    </div>
    <footer class="fixed-bottom navbar-light bg-white dn-footer" v-bind:class="{'invisible': invisible}">
      <div style="margin: 0 auto;width:90%;" v-bind:class="{'invisible': progress_invisible}">
        <div class="progress" style="width:100%;height:5px;background-color:#d2d2d2;">
          <div class="progress-bar" role="progressbar" style="background-color:#ffc8aa;" v-bind:style="{width: progress}" aria-valuemin="0" aria-valuemax="100"></div>
        </div>
        <div class="dn-font-10" style="color:#d2d2d2;margin-top:-1rem;text-align:left;">{{progress}}</div>
      </div>
      <div class="container dn-footer-div" >
        <div>
          <p class="btn dn-btn-pre" @click="$router.go(-1)" style="color:white;">
            上一步
          </p>
        </div>
        <div>
          <router-link class="btn dn-btn-next" :to="{path: pathModel, query:{toPage,qd}}" push>{{nextBtnName}}</router-link>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { Loading } from 'element-ui'

let loading

export default {
  name: 'App',
  beforeCreate () {
  },
  created () {
    this.routeChange(this.$route.name, this.$route.query.toPage, '')
    this.open = false
  },
  provide () {
  },
  data () {
    return {
      nav_invisible: false,
      invisible: true,
      open: false,
      navshow: false,
      nav_item_active: false,
      heading: '请选择您所需要安装的产品',
      subtitle: '',
      // 上一步
      lastpage: '',
      lastmodel: '',
      // 下一步
      toPage: '',
      pathModel: '/main',
      // pagehistory
      pagehistory: '/home',
      // 获取page-config
      pageConfig: '',
      topageConfig: '',
      // 按钮名称
      nextBtnName: '下一步',
      // 进度
      progress: '0%',
      progress_invisible: false,
      // 记录是否点击共用
      is_share: 'noshare',
      // 客服链接
      link: 'https://work.weixin.qq.com/kfid/kfc91b31322b344fa2f',
      // 渠道
      qd: '',
      quickInstallUrl: 'http://support.dailyneaty.com/qsg/#/home'
    }
  },
  methods: {
    // 通用方法
    routeChange: function (name, toPage, from) {
      this.open = false
      this.navshow = false
      this.nextBtnName = '下一步'
      this.nav_invisible = false
      this.invisible = false
      this.subtitle = ''
      if (name === 'czdb' || name === 'AssiPage' || name === 'EndPage') {
        this.nav_invisible = true
        this.invisible = true
        this.nextBtnName = '回到首页'
        this.pathModel = '/home'
      } if (name === 'xxxz') {
        this.invisible = true
        this.nextBtnName = '回到首页'
        this.pathModel = '/home'
        this.heading = ''
      } else if (name === 'home' || name==='dualLens') {
        this.invisible = true
        this.heading = '请选择您所需要安装的产品'
        this.subtitle = ''
      } else {
        this.invisible = false
        this.pageConfig = this.$global.filter(item => item.page === toPage)[0]
        this.heading = this.pageConfig.heading
        this.subtitle = this.pageConfig.subtitle
        this.toPage = this.pageConfig.toPage
        if (this.toPage === 's5' && this.is_share === 'noshare') {
          this.toPage = 's8-0'
        }
        if (this.toPage === 'win5' && this.is_share === 'noshare') {
          this.toPage = 'win8'
        }
        if (this.toPage === 'nix5' && this.is_share === 'noshare') {
          this.toPage = 'nix8'
        }
        if (this.toPage.includes('dwm5') && this.is_share === 'noshare') {
          this.toPage = 'dwm7'
        }

        this.updateProgress(toPage);    // 更新进度条
        
        if (toPage === 'dryer1') {
          this.quickInstallUrl = 'http://support.dailyneaty.com/qsg/#/model1?toPage=dryer1'
        }
        if (toPage === 'dwm1') {
          this.quickInstallUrl = 'http://support.dailyneaty.com/qsg/#/model1?toPage=dwm1'
        }

        this.topageConfig = this.$global.filter(item => item.page === this.toPage)[0]
        if (toPage === 'wt4' || toPage === 'nix10' || toPage === 'win9' || toPage === 's9' || toPage === 'wv3-0' || toPage === 'dryer4' || toPage === 'dwm9' || toPage === 'dgm9' || toPage==='dxm7') {
          this.pathModel = '/EndPage'
          this.nav_invisible = false
        } else if (typeof this.topageConfig != 'undefined' && this.topageConfig.videoSrc !== '') {
          this.pathModel = '/model1'
        } else if (typeof this.topageConfig != 'undefined' && this.topageConfig.pj.length === 1) {
          this.pathModel = '/model3'
        } else {
          this.pathModel = '/model2'
        }
      }

      if (from.query !== undefined) {
        this.qd = from.query.qd || from.query.q || ''
      }

    },
    updateProgress(toPage) { 
      this.progress = this.pageConfig.progress
      if (this.progress === '0%') {
        this.progress_invisible = true
      } else {
        this.progress_invisible = false
      }

      if (toPage === 's8-0' && this.is_share === 'noshare') {
        this.progress = '70%'
      }

      if (toPage === 's8-1' && this.is_share === 'noshare') {
        this.progress = '85%'
      }
    },
    menuShow: function () {
      if (this.navshow === false) {
        this.navshow = true
      } else {
        this.navshow = false
      }
    },
    offcanvasOpen: function () {
      if (this.open === false) {
        this.open = true
      } else {
        this.open = false
      }
    },
    offcanvasOpen2: function () {
      if (this.open === true) {
        this.open = false
      }
    },
    // 客服链接
    openWXKF: async function () {
      loading = Loading.service({
        lock: true,
        text: '正在跳转在线客服...',
        background: 'rgba(0, 0, 0, 0.7)', // 遮罩层颜色
        spinner: 'el-icon-loading',
        target: 'html',
        fullscreen: true
      })

      await setTimeout(function () {
        window.location.href = 'https://work.weixin.qq.com/kfid/kfc91b31322b344fa2f'
        loading.close()
      }, 3000)
    }
  },
  watch: {
    $route (to, from) {
      // 在组件创建后导航  
      if (to.name === 'home' || to.name ==='dualLens') {
        this.invisible = true
        this.heading = '请选择您所需要安装的产品'
        this.subtitle = ''
      }
      if (to.name === 'czdb') {
        this.invisible = true
        this.nav_invisible = true
      }
      if (to.query.toPage !== undefined) {
        if (this.pagehistory.indexOf(to.query.toPage) > 0) {
          this.pagehistory = this.pagehistory.substring(0, this.pagehistory.lastIndexOf(','))
        } else {
          this.pagehistory = this.pagehistory + ',/' + to.query.toPage
        }

        this.routeChange(to.name, to.query.toPage, from)
      }
    }
  }
}

</script>

<style scoped>
#app {
  /**font-family: 'Avenir', Helvetica, Arial, sans-serif;**/
  font-family: YZBold;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.router-link-active {
  text-decoration: none;
  color: white;
  text-align: center;
}

a:hover{
  color: #ffc8aa;
}

.yz-offcanvas-collapse {
  width: 0rem;
  left: 0;
  top: 3rem;
  padding: 0;
}

.open{
  max-width: 2000px;
  width: 13rem;
}
</style>



// WEBPACK FOOTER //
// src/App.vue